import { Action, ActionReducer, MetaReducer, State } from "@ngrx/store";
//import { storageSync } from "ngrx-store-ionic-storage";
import { storageSync } from "./meta-reducers/ionic-storage-sync-meta-reducer";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { LoggerService } from "src/service/logger.service";

export function onSyncError(err) {
  LoggerService.logStatic(
    LogLevel.LOG_ERROR,
    "Meta-reducers",
    "Meta-reducers",
    "onSyncError()",
    "ERROR IN META-REDUCERS: " + (err?.message ?? JSON.stringify(err))
  );
}

export const storageSyncReducer = storageSync({
  keys: [
    AppSettings.KEY_PLANTS,
    AppSettings.KEY_CURRENT_PLANT,
    AppSettings.KEY_USER,
    AppSettings.KEY_CLIENT_OPTIONS,
    AppSettings.KEY_SETTINGS,
    AppSettings.KEY_NOTIFICATION,
    AppSettings.KEY_AREA,
    AppSettings.KEY_CHART,
    AppSettings.KEY_ENVIRONMENT,
    AppSettings.KEY_ENVIRONMENT_DEVICE,
    AppSettings.KEY_TRANSLATION,
    AppSettings.KEY_TIMESLOT,
    AppSettings.KEY_GROUP_TIMESLOT,
    AppSettings.KEY_DEVICE_CARD_LIST,
    AppSettings.KEY_HISTORY_TRANSIT,
    AppSettings.KEY_GATEWAYS,
    AppSettings.KEY_GATEWAYS_SETTINGS,
    AppSettings.KEY_CARD_PROGRAMMER,
    AppSettings.KEY_PLANT_CODES,
    AppSettings.KEY_BUILDINGS,
    AppSettings.KEY_CURRENT_BUILDING,
    AppSettings.KEY_BLACK_BOX,
    AppSettings.KEY_SCENARIOS,
    AppSettings.KEY_SCENARIOS_COMMANDS,
  ], // Only sync the `collection` state
  ignoreActions: [],
  hydratedStateKey: "hydrated", // Add this key to the state
  onSyncError: onSyncError, // If a sync fails
});

export function storageMetaReducer(
  reducer: ActionReducer<any>
): ActionReducer<any, any> {
  return storageSyncReducer(reducer);
}

export const metaReducers: MetaReducer<any, any>[] = [storageMetaReducer];
